module.exports = __webpack_public_path__ + "assets/img/RSPCA-Pet-Insurance-Pillar-Page-Resource-w540.391ca410.webp";